import React from "react"
import LinkArrow from "../../svg/new/LinkArrow"
import * as style from "./scrollButton.module.css"

const ScrollButton = ({
  btnText,
  customClass,
  onClick = () => {},
  styles,
  disabled = false,
}) => {
  return (
    <button
      style={styles}
      className={` ${style.btn_red} ${customClass}`}
      onClick={() => onClick()}
      type="submit"
      disabled={disabled}
    >
      {btnText}
      <i>
        <LinkArrow />
      </i>
    </button>
  )
}

export default ScrollButton
